import gql from 'graphql-tag'

export const FEATURE_FLAGS_LIST_QUERY = gql`
  query FeatureFlagsList($schoolId: Int) {
    featureFlagsList {
      id
      enabled
    }

    school(id: $schoolId) {
      id
      featureFlags {
        id
        enabled
      }
    }
  }
`
